import React from "react";
import { FormProvider } from "react-hook-form";
import { IconButton } from "@mui/material";

import { RFHTextField as RHFTextField } from '../RFH'
import TextEditor from "../../features/board/components/textEditor/textEditor";
import InputFileUpload from "../FileUploadButton";
import { DeleteIcone } from "../UI/Icons.js";
import { useFeedbackFormState } from "./hooks/useFeedbackFormState";

export const FeedbackDialogContent = React.memo(({ schema, handleClose }) => {
  const {
    errors,
    handleDeleteFile,
    handleSelectedFiles,
    methods,
    onSubmit,
    selectedFiles,
    textContent,
    updateMessage,
  } = useFeedbackFormState(schema, handleClose);
  const { register, getValues, watch, handleSubmit } = methods;

  return (
    <>
      <FormProvider {...methods}>
        <form
          id="feedbackForm"
          className="feedback-form"
          onSubmit={handleSubmit(onSubmit)}>
          <p className="text">
            Thanks for trying TaskBoard!
            <br />
            If you have <b>questions about features,</b> need{" "}
            <b>help solving a problem</b> using Taskboard, or found a bug,
            please use the form below for{" "}
            <b>support requests, bug reports, and suggestions.</b>
          </p>
          <p className="text label-text">Subject</p>
          <RHFTextField name={"subject"} />
          <p className="text label-text">Description</p>
          <TextEditor
            id="message"
            name="message"
            description={""}
            setTextContent={updateMessage}
            {...register("message")}
          />
          {errors?.message && textContent === "" && (
            <p className="error-message">{errors?.message?.message}</p>
          )}
          <p className="text label-text">Attachments</p>
          <InputFileUpload
            watch={watch}
            register={register}
            getValues={getValues}
            name={"attachments"}
            fileChange={handleSelectedFiles}
          />
          <ul className="files-list">
            {selectedFiles?.length > 0 &&
              selectedFiles?.map((file, index) => (
                <li
                  key={`${file?.name}-${index}`}
                  className="d-flex justify-content-space-between text">
                  {file?.name}
                  <IconButton onClick={() => handleDeleteFile(file?.name)}>
                    <DeleteIcone height="24px" width="24px" />
                  </IconButton>
                </li>
              ))}
          </ul>
        </form>
      </FormProvider>
    </>
  );
});
